import { useDispatch, useSelector } from "react-redux";
import { releaseNoteAdded, selectAllReleaseNotes } from "./releaseNotesSlice";

const AddReleaseNoteForm = () => {

    const dispatch = useDispatch();
    const startingReleaseNotes = useSelector(selectAllReleaseNotes);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { elements } = e.currentTarget;

        let dateDisplay;
        try {
            //Converts 2025-07-09 to July 9, 2025
            const date = new Date(elements.releaseNoteReleasedate.value + 'T00:00:00'); // The 'T00:00:00' is added so it's parsed in the local time zone.
            dateDisplay = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); // July 9, 2025
        } catch (error) {
            console.log(error);
        }

        const releaseNoteBody = {
            id: startingReleaseNotes.length.toString(),
            toolname: elements.releaseNoteToolname.value,
            releasenumber: elements.releaseNoteReleasenumber.value,
            releasedate: elements.releaseNoteReleasedate.value,
            dateDisplay: dateDisplay,
            releasedescription: elements.releaseNoteReleasedescription.value,
        }
        startingReleaseNotes.push(releaseNoteBody);
        const form = e.currentTarget;
        try {
            dispatch(releaseNoteAdded(releaseNoteBody));
            form.reset();
        } catch (err) {
            console.error("Failed to save the update: ", err);
        }
    }

    //editing in progress
    return <div>
    <h2>Add a New Release Note Entry</h2>
    <form onSubmit={handleSubmit}>
        <label htmlFor="releaseNoteToolname">Tool Name</label>
        <input type="text" style={{width: "700px"}} id="releaseNoteToolname" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteReleasenumber">Release Number</label>
        <input type="text" id="releaseNoteReleasenumber" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteReleasedate">Date (YYYY-MM-DD)</label>
        <input type="text" id="releaseNoteReleasedate" defaultValue={(new Date().toISOString().split('T')[0])} required />
        <br/>
        {/* This field commented out because it's automatically calculated on handleSubmit
        <label htmlFor="releaseNoteDateDisplay">Date Display (Month D, YYYY)</label>
        <input type="text" id="releaseNoteDateDisplay" defaultValue={(new Date()).toLocaleDateString('en-US', {  year: 'numeric',  month: 'long',  day: 'numeric' })} required />
        <br/> */}
        <label htmlFor="releaseNoteReleasedescription">Description</label>
        <input type="text" style={{width: "1700px"}}  id="releaseNoteReleasedescription" defaultValue="" required />
        <br/>
        <button>Add Entry</button>
    </form>
    <br/>
</div>
}

export default AddReleaseNoteForm;